"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getProps(_ref) {
  var asset = _ref.asset,
      selected = _ref.selected,
      selectedLabels = _ref.selectedLabels,
      labels = _ref.labels,
      canUpdateVideo = _ref.canUpdateVideo,
      inverseColours = _ref.inverseColours,
      hideFileTypeIcon = _ref.hideFileTypeIcon;
  return {
    asset: asset,
    selected: selected,
    selectedLabels: selectedLabels,
    labels: labels,
    canUpdateVideo: canUpdateVideo,
    inverseColours: inverseColours,
    hideFileTypeIcon: hideFileTypeIcon
  };
}

function hasChanges(propsA, propsB) {
  return !(0, _lodash.default)(getProps(propsA), getProps(propsB));
}

var _default = (0, _memoizeOne.default)(hasChanges);

exports.default = _default;